// 法
module.exports = {
  common: {
    edit: "modifier",
    apply: "Appliquer",
    activate: "Activation",
    delete: "supprimer",
    cancel: "Annuler",
    success: "succès",
    fail: "échouer",
    save: "sauvegarder",
    ensure: "Bien sûr",
    submit: "soumettre",
    remark: "Remarque",
    detail: "Vérifier",
    action: "fonctionner",
    open: "ouvrir",
    close: "fermeture",
    back: "retour",
    export: "exporter",
    modify: "Réviser",
    layout: "se déconnecter",
    noListData: "La liste n'a pas de données",
    more: "Détails",
    add: "Ajouter",
    delSuccess: "supprimé avec succès !",
    addFailure: "l'ajout a échoué !",
    logOut: "Se déconnecter",
    delAllInfo: "Voulez-vous continuer l'opération de suppression ?",
    saveTip:
      "Vous n'avez pas enregistré le contenu de la page, voulez-vous continuer à partir ?",
    tip: "indice",
    yes: "Oui",
    no: "Non",
    delTip: "Cocher pour activer",
    batchDelete: "suppression par lots",
    search: "Renseigner",
    permission: "Pas encore d'autorisation, veuillez revenir en arrière",
    reset: "réinitialiser",
  },
  breadcrumbItem: {
    home: "Configuration de la liste de noms",
    data: "Emballage de la configuration générale de l'appareil",
    alarm: "Configuration des zones",
    house: "Configuration de l'aménagement de la maison",
    name: "Configuration de la liste de noms",
  },
  errorRes: {
    res82: "Le système est occupé, veuillez réessayer plus tard",
  },
  openConfig: {
    title: "Configuration générale de l'appareil",
    version: "Version de protocole",
    versionTip: "Veuillez sélectionner une version de protocole",
    checkVersion:
      "La version du protocole ne peut pas être vide, veuillez choisir à nouveau",
    signType: "Type d'algorithme de signature",
    checkSignType:
      "Le type d'algorithme de signature ne peut pas être vide, veuillez choisir à nouveau",
    fileLabel: "Sélectionner un document",
    addFile: "Ajouter des fichiers",
    fileName: "nom de fichier",
    zipType: "Méthode de compression",
    noZip: "pas de compression",
    noFile: "Aucun fichier ajouté pour le moment",
    checkFile:
      "Le fichier de configuration est vide, veuillez ajouter un fichier",
    name: "nom",
    nameTip: "La longueur d'entrée est de 1 à 10 chiffres",
    checkName: "Le nom ne peut pas être vide, veuillez le saisir à nouveau",
    checkName1: "Entrée de nom incorrecte, veuillez ré-entrer",
    room: "Reference de l'appareil",
    roomTip:
      "La longueur d ' entrée est de 1 à 24 bits et le niveau se distingue par -",
    checkRoom:
      "Le numéro d'appareil ne peut pas être vide, veuillez le saisir à nouveau",
    checkRoom1:
      "La saisie du numéro d'appareil est incorrecte, veuillez le saisir à nouveau",
    pic: "image",
    add: "Ajouter à",
    reset: "réinitialiser",
    picTip:
      "La taille maximale de téléchargement d'un fichier image est de 3 m",
    checkPic: "Le fichier image ne peut pas être vide, veuillez resélectionner",
    imgRegTip: "Téléchargez uniquement des fichiers aux formats jpg, jpeg, png",
    excRegTip: "Téléchargez uniquement des fichiers au format xls et xlsx",
    zipRegTip: "Ne télécharger que des fichiers au format zip",
    produce: "Générer le fichier de configuration",
    confType: "Type de configuration",
    pack: "Paquet",
    batchAdd: "Ajouter par lots",
    singleAdd: "Ajout unique",
    modelBatch: "Télécharger le modèle d'importation par lots",
    uploadInfo: "Télécharger les informations de base Excel",
    uploadPic: "Télécharger le package d'image Zip",
    addName: "Ajouter une seule donnée",
    sameTip: "Numéro de série:",
    sameTip1: "Numéro d'appareil en double",
    modelError:
      "Le contenu du fichier d'informations de base téléchargé est incorrect, veuillez modifier le fichier en fonction du modèle",
    noPic:
      "Il y a des données dans la liste qui n'ont pas été ajoutées avec des images, vous devez compléter les images avant de générer le fichier de configuration",
    picBtnTip: "Veuillez d'abord télécharger le fichier d'informations de base",
    devType: "Type d'équipement",
    devTypeTip: "Veuillez sélectionner un type d'appareil",
    checkDevType:
      "Le type d'appareil ne peut pas être vide, veuillez choisir à nouveau",
    indexName: "numéro de série",
    IS: "Unité intérieure",
    GU: "Appareil de gestion",
    OS1: "Boîte vocale",
    OS2: "Machine murale",
    OS3: "Petit poste de porte",
    nameListTip:
      "Dans les données de base téléchargées, il y a des données avec un champ de nom incomplet, et le reste des données correctes a été importé",
    numListTip:
      "Dans les données de base téléchargées, il y a des données incomplètes dans le champ du numéro d'appareil, et le reste des données correctes a été importé",
  },
  alarm: {
    ad: "Zone AD",
    io: "Zone E/S",
    alarmPlus: "Agrandissement de zones",
    num: "numéro de série",
    open: "ouvrir",
    close: "fermer",
    machine: "Type de détecteur",
    sendType: "Type de déclenchement",
    mode: "modèle",
    mType1: "infrarouge",
    mType2: "Porte Magnétique",
    mType3: "aimant de fenêtre",
    mType4: "gaz",
    mType5: "fumée",
    mType6: "sonnette",
    mType7: "Bouton Newsletter",
    mType8: "Capteur de porte infrarouge",
    mType9: "Capteur de porte d'alarme manuelle",
    mType10: "vibration",
    mType11: "pression de l'air",
    mType12: "autre",
    send1: "Signaler immédiatement dans les 24 heures",
    send2: "Alarme retardée",
    send3: "Délai de transfert",
    send4: "Appelez la police immédiatement",
    send5: " Alarme croisée ",
    mode1: "Normalement ouvert",
    mode2: "Souvent éteint",
    presence: "à la maison",
    leaving: "quitter la maison",
    timeSet: "Réglage de l'heure liée au bras",
    delayTime: "Délai effectif d'armement (secondes)",
    startDelay: "Délai de déclenchement d'alarme (secondes)",
    startUtil: "Durée de l'alarme (minutes)",
    associated: "Zone associée",
  },
  house: {
    dev: "équipement",
    scene: "Scènes",
    vine: "capteur",
    single: "Contrôle indépendant des scènes",
    light: "lumière",
    air: "climatiseur",
    heat: "chauffage au sol",
    fresh: "Vent frais",
    switch: "Prise de commutateur",
    curtain: "rideau",
    water: "chauffe-eau",
    bgm: "Musique de fond",
    cust: "Appareil personnalisé",
    slight: "lumière",
    sAir: "climatiseur",
    sHeat: "chauffage au sol",
    sFresh: "Vent frais",
    sSwitch: "Prise de commutateur",
    sCurtain: "rideau",
    sWater: "chauffe-eau",
    sBgm: "Musique de fond",
    sCust: "Appareil personnalisé",
    IndependentControl: "Contrôle indépendant des scènes",
    scene1: "scène 1",
    scene2: "Scène 2",
    scene3: "Scène 3",
    scene4: "Scène 4",
    scene5: "Scène 5",
    scene6: "Scène 6",
    scene7: "Scène 7",
    scene8: "Scène 8",
    temp1: "température",
    temp2: "humidité",
    temp3: "méthane",
    temp4: "gaz organique",
    picTip: "Il n'y a pas de plan d'étage",
    upload: "Télécharger le plan d'étage",
    imgSize:
      "La taille de l'image d'un seul plan d'étage ne doit pas dépasser 10M",
    imgName:
      "Le nom du fichier de plan d'étage téléchargé ne doit pas apparaître en chinois, veuillez choisir à nouveau",
    imgLength:
      "Le nombre total de téléchargements et d'ajouts de plans d'étage ne doit pas dépasser 8, et les 8 premières images du dossier ont été automatiquement sélectionnées",
    imgCheckTip: "Le plan d'étage ne correspond pas, veuillez re-télécharger",
    room1: "Maison type 1",
    room2: "Maison Type 2",
    room3: "Maison Type 3",
    room4: "Maison Type 4",
    room5: "Maison Type 5",
    room6: "Maison Type 6",
    room7: "Maison Type 7",
    room8: "Type de maison Figure 8",
    download: "exporter",
    input: "Configuration d'importation",
    title: "Tableau des paramètres de l'équipement",
    name: "nom",
    location: "Emplacement",
    start: "Commencez",
    see: "visible",
    noSee: "Invisible",
    belong: "appartient à",
    bgIcon: "Icône bleu gris",
    vineTip:
      "Veuillez sélectionner le plan d'étage avant de définir les propriétés de contrôle de la température",
    sceneTip:
      "Veuillez sélectionner le plan d'étage, puis définir les propriétés de la scène",
    dragTip:
      "Veuillez sélectionner le plan d'étage avant d'effectuer l'opération de glissement",
    editTip: "Modifié avec succès",
    addTip:
      "Lors du téléchargement, vous devez sélectionner tous les plans d'étage à la fois",
    editError: "Veuillez spécifier le contenu de l'édition avant l'édition",
    delError: "Veuillez préciser le contenu à supprimer avant de supprimer",
    delTip: "supprimé avec succès",
    imgAddTip:
      "Le nombre total de plans d'étage téléchargés et ajoutés a atteint 8, et aucun autre ne peut être ajouté",
    houseTitle: "Changement de carte de type de maison :",
    delHouseTip:
      "Cette opération supprimera le plan d'étage et le contenu de la configuration. Voulez-vous continuer ?",
    sendTip:
      "Importez le contenu de la configuration à modifier à nouveau, vous pouvez uploader le fichier xml",
    checkType:
      "Le format du fichier téléchargé est incorrect, veuillez vérifier le contenu du fichier et le télécharger à nouveau",
    importTip: "Importer le fichier de configuration",
    importTip1: "Importer le plan d'étage correspondant",
    upLoadBtn: "Télécharger",
    picContent:
      "L'ordre de téléchargement des plans d'étage doit être cohérent avec l'ordre des plans d'étage dans le fichier de configuration",
    successFile: "Fichier de configuration téléchargé avec succès",
    vineTipCheck: "Le nom ne peut pas être vide, veuillez confirmer la saisie",
    picNumMax:
      "Veuillez confirmer le nombre d'images importées. Le nombre actuel d'images importées est supérieur au nombre de plans de maison dans le fichier de configuration. Veuillez resélectionner",
    picNumMin:
      "Veuillez confirmer le nombre d'images importées. Le nombre actuel d'images importées est inférieur au nombre de plans de maison dans le fichier de configuration. Veuillez choisir à nouveau",
    maxSizeTip:
      "Le nombre ou le nombre total d'ajouts de ce type dépasse la limite. Si vous devez en ajouter, veuillez d'abord trier les appareils ou scènes ajoutés.",
    devNameTip: "Veuillez entrer un nom",
    chromeTip: "Le navigateur Chrome est recommandé",
    downTip: "Cliquez pour accéder au lien de téléchargement",
    imgRegTip: "Téléchargez uniquement des fichiers aux formats jpg et jpeg",
    threeTitle: "Système à trois constantes",
    mainControl: "maître",
    sedControl: "sous-contrôle",
    controlBtn: "Configuration",
    configEdit: "Détails de la configuration du système Sanheng",
    moveTip:
      "Veuillez faire glisser l'icône vers la zone du plan d'étage, veuillez la faire glisser à nouveau",
    repeatNameTip:
      "Impossible de télécharger des plans d'étage avec le même nom, veuillez sélectionner à nouveau",
    space: "(Réservé)",
  },
  updateConfig: {
    tip0: "Lors du réglage de l'alarme 24 heures, réglez l'interrupteur sur ON",
    tip1: "Lors du réglage de l'alarme 24 heures, le commutateur doit être activé",
    tip2: "Lors du réglage d'une alarme immédiate, l'interrupteur doit être activé",
    tip3: "Lorsque l'alarme de retard est désactivée, le délai de livraison doit être désactivé",
    tip4: "L'alarme croisée a été définie, nécessite une opération associée",
    tip5: "Veuillez d'abord activer l'alarme de retard",
    tip6: "Lors du réglage de l'alarme immédiate, mettez l'interrupteur sur marche",
  },
  audio: {
    title: "Outil d'emballage des indications vocales",
    lock: "Son de déverrouillage",
    call: "Son d'appel",
    speak: "Son d'appel en cours",
    busy: "Son occupé",
    tip1: "Cliquez pour télécharger le fichier au format .wav",
    tip2: "La taille du fichier ne doit pas dépasser 1 Mo",
    tip3: "Veuillez télécharger un fichier au format .wav",
    tip4: "Veuillez télécharger tous les fichiers",
    add: "Générer des fichiers",
  },
  threeProject: {
    hotWater: "Système de chauffage d'eau",
    cho: "Formaldéhyde",
    config: "Configurer",
    unconfig: "Ne pas configurer",
  },
  elevator: {
    title: "Générateur de configuration de contrôle d'ascenseur",
    label: "Téléverser la feuille de configuration",
    uploadTip: "Cliquez ou glissez-déposez le fichier ici pour téléverser",
    upload: "Téléverser",
    download: "Télécharger le modèle",
    downloadTip:
      "Cliquez pour télécharger le modèle de feuille de configuration",
    error1:
      "[Étage physique] erroné. Veuillez vérifier le fichier de configuration puis réimporter",
    error2:
      "[Étage d'affichage] erroné. Veuillez vérifier le fichier de configuration puis réimporter",
    error3:
      "[Adresse de la passerelle de contrôle] erronée. Veuillez vérifier le fichier de configuration puis réimporter",
    error4:
      "[Affichage du numéro d'ascenseur] erroné. Veuillez vérifier le fichier de configuration puis réimporter",
    error5:
      "[IP de l'appareil] erronée. Veuillez vérifier le fichier de configuration puis réimporter",
    error6:
      "[Passerelle de contrôle d'ascenseur] nombre limite dépassé. Veuillez vérifier le fichier de configuration puis réimporter",
    generate: "Modèle de feuille de configuration",
    fileLabel: "Fichier de configuration d'ascenseur :",
    tip: "Veuillez placer le fichier de configuration dans la section [Mise à niveau des ressources] de l'outil PC pour l'importer dans l'appareil",
    downloadfile: "Télécharger",
    fileName: "ConfigurationControleAscenseur.xlsx",
    formatError:
      "Le format du fichier téléchargé est incorrect, veuillez vérifier le contenu du fichier puis le télécharger à nouveau",
  },
};
